import React, { useContext, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Popup from "../common/popup/Popup";
import { useEffect } from "react";

export default function CreateTickitPopup({ isopen, handleClose }) {
  const token = sessionStorage.getItem("token");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const initialized = useRef(false);
  const [files, setFiles] = useState([]);
  const [paymentTab, setPaymentTab] = useState("tab1");
  const [currentAccount, setCurrentAccount] = useState();
  const [isBankTransfer, setIsBankTransfer] = useState([]);
  const [isUPI, setIsUPI] = useState([]);
  const [isPaytm, setIsPaytm] = useState([]);
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false); // Track if form is submitted


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitted) return;

    // Note validation
    const trimmedNote = note.trim();

    if (!trimmedNote) {
      setErrors({
        note: "Please enter your issue or query."
      });
      return;
    }

    setErrors({});

    setIsSubmitted(true);

    try {
      const token = sessionStorage.getItem("token");
      const formdata = new FormData();
      formdata.append("message", trimmedNote);
      Array.from(files || []).forEach((file) => {
        formdata.append("files[]", file, file.name);
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/support/tickets`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formdata,
          redirect: "follow",
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Ticket submission failed");
      }

      setIsUpdate(true);
      setTimeout(() => {
        setIsUpdate(false);
        handleClose();
      }, 2000);
      setNote("");
      setFiles([]);
      e.target.reset();

    } catch (error) {
      setIsError(true);
      setErrorMsg(error.message || "Something went wrong!");

      setTimeout(() => {
        setIsError(false);
      }, 3000);
    } finally {
      setIsSubmitted(false);
    }
  };


  const getPaymentDetails = () => {
    const myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJBIjoiNjczYzYzY2NmNjU0ZmQxYjYyOGY3ODM4IiwiaWF0IjoxNzM3MzUxNjUxLCJleHAiOjE3MzkxNTE2NTF9.UZtwCY075h8vN0TKomgLxGHElBpuR1cc_WbEkUqGk4c");
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "page": "0",
      "pmethod": "All"
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/payment/paymentmethodlist`, requestOptions)
      .then(async (response) => {
        let paresData = await response.json();
        if (response.ok) {
          if (paresData && paresData.paymentMethodList.length > 0) {
            let bank = paresData.paymentMethodList.filter(item => item.pmethod === "banktransferW" && item.status);
            let upi = paresData.paymentMethodList.filter(item => item.pmethod === "upiW" && item.status);
            let paytm = paresData.paymentMethodList.filter(item => item.pmethod === "paytmW" && item.status);
            console.log("111111111111111111111111111111111111111111111111111111111");

            setIsBankTransfer(bank)
            setIsUPI(upi)
            setIsPaytm(paytm)
            if (paymentTab === 'tab1') {
              if (bank.length > 0) {
                setCurrentAccount(bank[0]);
              } else {
                setCurrentAccount();
              }
            } else if (paymentTab === 'tab2') {
              if (upi.length > 0) {
                setCurrentAccount(upi[0]);
              } else {
                setCurrentAccount();
              }
            } else if (paymentTab === 'tab3') {
              if (paytm.length > 0) {
                setCurrentAccount(paytm[0]);
              } else {
                setCurrentAccount();
              }
            }
          } else {
            setIsBankTransfer([])
            setIsUPI([])
            setIsPaytm([])
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (isopen && !initialized.current) {
      initialized.current = true;
      getPaymentDetails();
    }

  }, [isopen, currentAccount]);

  const getMainForm = () => {
    return (
      <>
        <div
          className="enter-payment-detail"
          style={{ margin: "0", padding: "0", border: "0" }}
        >
          <form
            className="payment-fom"
            id="ticketCreateForm"
            method="post"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <div className="input-box">
              <label>Describe Your Issue or Query</label>
              <textarea
                placeholder="Enter full details of your issue or question..."
                name="message"
                rows={4}
                value={note}
                onChange={(e) => {
                  setNote(e.target.value);

                  if (e.target.value.trim()) {
                    setErrors((prev) => ({
                      ...prev,
                      note: ""
                    }));
                  }
                }}
                required
              />
              {errors.note && (
                <span className="error">{errors.note}</span>
              )}
            </div>

            <div className="input-box">
              <label>Attach File / Screenshot (Optional)</label>
              <input
                type="file"
                name="files[]"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.pdf,.webp"
                onChange={(e) => setFiles(e.target.files)}
              />
              <span className="error">
                Allowed: JPG, PNG, GIF, PDF, WEBP (Max 5MB)
              </span>
            </div>

            <div className="btn-sec">
              <button
                type="submit"
                disabled={isSubmitted}
                className="btn change-pass-model-form-submit-btn"
              >
                Submit Ticket
              </button>
            </div>
          </form>
        </div>
      </>
    );
  };

  return (
    <>
      <Modal
        show={isopen}
        onHide={() => { handleClose(); initialized.current = false; }}
        className="menu-dropdown-popup stack-chnage-popup paymentDepositePopup"
        dialogClassName="v-center"
      >
        <Modal.Header closeButton>
          <h2>
            {" "}
            <span className="title-v-border"></span> Create New Ticket
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div
            className="create-tickit"
            style={{
              width: "100%",
              boxSizing: "border-box"
            }}
          >
            <div
              className="create-tickit-payment-tab"
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                boxSizing: "border-box"
              }}
            >
              {getMainForm()}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Popup
        popupClass={`alertMsgpopup ${isUpdate ? "open" : ""}`}
        content={
          <div className={`alert-msg success`}>
            <span className="msg">Ticket submitted successfully!</span>
            <div className="alert-progress-bar"></div>
          </div>
        }
      />

      <Popup
        popupClass={`alertMsgpopup ${isError ? "open" : ""}`}
        content={
          <div className={`alert-msg err`}>
            <span className="msg">{errorMsg}</span>
            <div className="alert-progress-bar"></div>
          </div>
        }
      />
    </>
  );
}
